import React, { useState, useEffect } from 'react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import NoticeCard from './NoticeCard';
import { apiUrl, apiUrl2 } from '../../common/urls';
import axios from 'axios';
// import useNoticeList from "@/src/hooks/queries/useNoticeList";

const FooterNoticeSwiper = ({ id }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [list, setList] = useState([]);

  const getData = async () => {
    const result = await axios.get(apiUrl2 + '/footerNotice');
    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      setList(result.data[0].listData);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // console.log(list);

  // console.log(list);
  return (
    list.length > 0 && (
      <Swiper
        className={`swiper noti_swiper foot_noti`}
        slidesPerView={1}
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        pagination={{
          clickable: true,
          type: 'fraction',
          el: '.swiper-pagination',
        }}
        navigation={{
          prevEl: `#notice-swiper-button-prev-${id}`,
          nextEl: `#notice-swiper-button-next-${id}`,
        }}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        speed={10}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.activeIndex);
        }}
      >
        {list.map((notice) => {
          return (
            <SwiperSlide key={`notice-${notice.idx}`}>
              <NoticeCard notice={notice} />
            </SwiperSlide>
          );
        })}
        <div
          id={`notice-swiper-button-next-${id}`}
          className="swiper-button-next"
          style={{
            display: activeIndex === list.length - 1 ? 'none' : undefined,
          }}
        />
        <div
          id={`notice-swiper-button-prev-${id}`}
          className="swiper-button-prev"
          style={{
            display: activeIndex === 0 ? 'none' : undefined,
          }}
        />
        <div
          id={`notice-swiper-paginaition-${id}`}
          className="swiper-pagination"
        />
      </Swiper>
    )
  );
};

export default FooterNoticeSwiper;
